import React, { useState, useEffect } from 'react';

interface ConnectionStatusProps {
  style?: React.CSSProperties;
}

export const ConnectionStatus: React.FC<ConnectionStatusProps> = ({ style }) => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  if (isOnline) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        background: 'var(--destructive)',
        color: 'white',
        padding: 8,
        textAlign: 'center',
        fontSize: 14,
        fontWeight: 500,
        zIndex: 9999,
        ...style,
      }}
    >
      Sem conexão com a internet. Verifique sua conexão.
    </div>
  );
};
